import {PlayerEvent} from './player-event';

export class PlayerProfileEvent
{
  id: number;
  registrationDate: Date;
  event: PlayerEvent;

  eventYear: number;
  eventMonth: number;
  eventDay: number;

  calendarSync: boolean;
  archive: boolean;
  participantId: number;
  participantName: string;
  teamId: number;

  public static initData(data: PlayerProfileEvent): void
  {
    if (data)
    {
      if (data.registrationDate)
        data.registrationDate = new Date(data.registrationDate);
      if (data.event?.datetime)
      {
        data.event.datetime = new Date(data.event.datetime);

        data.eventYear = data.event.datetime.getFullYear();
        data.eventMonth = data.event.datetime.getMonth();
        data.eventDay = data.event.datetime.getDate();
      }
    }
  }
}

